import type { EventShort } from '@/types/domain/plan';
import { planRequestService } from '@/api/plan';

export const eventsUpcomingShortGet = () => planRequestService<EventShort[]>({
    url: '/events/upcoming/short',
    method: 'GET'
});
